/**
 * menu模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const menu = {
  //菜单管理
  menuManagement(id,params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/menu/menuManagement`,param);
  },
  //查询当前用户的权限集合
  jurisdictionList(params) {
    return $http.post(`${global.API_URL}/sme/menu/jurisdictionList`,params);
  },
  //添加菜单
  menuCreate(params) {
    return $http.post(`${global.API_URL}/sme/menu/create`,params);
  },
  //编辑菜单
  menuUpdate(params) {
    return $http.post(`${global.API_URL}/sme/menu/update`,params);
  },
  //删除菜单
  menuDelete(id,params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/menu/delete`,param);
  },
  //菜单管理树状节点
  menuTreeNode(params) {
    return $http.post(`${global.API_URL}/sme/menu/menuTreeNode?menuType=${params.menuType}&companyId=${params.companyId}`);
  }

}

export default menu



// WEBPACK FOOTER //
// ./src/api/menu.js